import { render, staticRenderFns } from "./version-upload-form.vue?vue&type=template&id=74d151c6"
import script from "./version-upload-form.vue?vue&type=script&lang=js"
export * from "./version-upload-form.vue?vue&type=script&lang=js"
import style0 from "./version-upload-form.vue?vue&type=style&index=0&id=74d151c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports